import { notificationApi , bankSettingsApi } from "../../../api/apiClient"


function getGroups(){
    return notificationApi.get("/notifications/groups")
}

function getConfiguration() {
    return bankSettingsApi.get(`/bank/config`);
  }
  
function AddGroupUser(customerData){
    return notificationApi.post('/notifications/customers/add',customerData)
}

function EditGroupUser(data){
    return notificationApi.put(`/notifications/customers/update`,data)
}

function AddSingleUser(customerData){
    return notificationApi.post("/notifications/singelSubscriber",customerData)
}


function LoadSubscribers(data){
    return notificationApi.post("/notifications/customers", data)
}

function CheckStatus(data){
    return notificationApi.put("/notifications/customers/updateStatus",data)
}

function DeleteCustomer(data) {
    return notificationApi.put(`/notifications/customers/delete/${data}`)
}



function AssginmultiplesGroup(data){
    return notificationApi.post(`/notifications/customers/assign`,data)
}
export const customerList = { 
    getGroups,
    AddGroupUser,
    AddSingleUser,
    LoadSubscribers,
    CheckStatus,
    DeleteCustomer,
    EditGroupUser,
    AssginmultiplesGroup,
    getConfiguration
};

